import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSubscription,
  filterSubscription,
} from "../action/subscriptionAction";

const initialState = {
  isLoading: false,
  allSubscription: [],
  selectedSubscription: [],
};

export const subscriptionSlice = createSlice({
  name: "Subscription",
  initialState,
  reducers: {
    setSubscription: (state, action) => {
      state.selectedSubscription = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        const { data } = action.payload ?? [];
        state.allSubscription = data ?? [];
        state.selectedSubscription = data?.length !=0 ? data : [];
        state.isLoading = false;
      })
      .addCase(fetchSubscription.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error fetching subscription:", action.payload);
      });

    // filter-subscription
    builder
      .addCase(filterSubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(filterSubscription.fulfilled, (state, action) => {
        const { data } = action?.payload || {};
        state.userList = data ?? [];
        state.isLoading = false;
      })
      .addCase(filterSubscription.rejected, (state, action) => {
        console.error("Error filtering subscription:", action.payload);
        state.isLoading = false;
      });
  },
});

export const { setSubscription } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
